import React, { useEffect } from 'react';

import PropTypes from 'prop-types';
import { t } from 'ttag';

import Button from '../ui/button/button';
import Input from '../ui/input/input';
import Message from '../ui/message/message';
import Title from '../ui/title/title';

import { useUrlQueryParam } from '../../hooks/useUrlQueryParam';
import PageTitle from '../pageTitle/pageTitle';

// styles
import css from './remindPassForm.css';

/**
 *
 * @deprecated
 * @see `cs/components/remindPassForm/new/NewRemindPassForm.tsx`
 */
const RemindPassForm = (props) => {
    const email = useUrlQueryParam('email');

    const handleSubmitForm = (evt) => {
        evt.preventDefault();
        props.onValidateEmail();
        props.onSubmitForm();
    };

    useEffect(() => {
        if (email) {
            props.onChangeEmail(email);
        }
    }, [email]);

    return (
        <div className={css.root}>
            <PageTitle>{t`Відновлення пароля`}</PageTitle>
            <Title>{t`Відновлення пароля`}</Title>
            {props.isPassedSuccessful ? (
                <Message type="success" sizeSmall>
                    {t`Якщо вказаний користувач існує, то на email`}{' '}
                    <b>{props.email}</b>{' '}
                    {t`було надіслано посилання для відновлення пароля.`}
                </Message>
            ) : (
                <form onSubmit={handleSubmitForm}>
                    <div className={css.input}>
                        <div className={css.hint}>
                            {t`На цей email ми надішлемо посилання для відновлення пароля`}
                        </div>
                        <Input
                            placeholder={t`Наприклад, example@mail.com`}
                            onChange={(evt) =>
                                props.onChangeEmail(evt.target.value)
                            }
                            error={props.isInvalidEmail || props.isUnknownEmail}
                            errorMessage={props.errorMessage}
                            defaultValue={email}
                        />
                    </div>
                    <Button
                        type="submit"
                        theme="cta"
                        width="full"
                        isLoading={props.isLoading}
                    >
                        {t`Продовжити`}
                    </Button>
                </form>
            )}
        </div>
    );
};

RemindPassForm.propTypes = {
    isInvalidEmail: PropTypes.bool,
    isUnknownEmail: PropTypes.bool,
    isPassedSuccessful: PropTypes.bool,
    isLoading: PropTypes.bool,
    email: PropTypes.string,
    errorMessage: PropTypes.string,
    onChangeEmail: PropTypes.func.isRequired,
    onValidateEmail: PropTypes.func.isRequired,
    onSubmitForm: PropTypes.func.isRequired,
};

export default RemindPassForm;
